import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../helpers/AuthContext';
import { useContext } from 'react';

const SearchForm = ({ setPersonnels, setStats }) => {
  //let navigate = useNavigate();
  const { authState } = useContext(AuthContext);
  const user = authState.user;
  const [formFields, setFormFields] = useState({
    nomprenom: '',
    gradeId: '',
    etsouserviceId: '',
    brigadeId: [],
    bataillonId: [],
    compagnieId: [],
    operation: '',
    boadssId: '',
    exportExcel: false,
    fonction: '',
    pdl: false,
    annee: '',
    vague: '',
    observation: '',
    annee: '',
    vague: '',
    nonVerifier: false,
    diplomeadministratif: ''
  });

  const [etsouservice, setEtsouservices] = useState([]);
  const [grades, setGrades] = useState([]);

  const [brigade, setBrigade] = useState([]);
  const [bataillon, setBataillon] = useState([]);
  const [compagnie, setCompagnie] = useState([]);
  const [boaDss, setBoaDss] = useState([]);
  //const [stat, setStats] = useState(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      const [servivesRes, gradeRes, brigadeRes] = await Promise.all([axios.get('/etsouservice/'), axios.get('/grade/'), axios.get('/brigade/')]);
      setBrigade(brigadeRes.data);
      setGrades(gradeRes.data);
      setEtsouservices(servivesRes.data);
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (user?.roles === "USER" && brigade.length > 0) {

      const username = user.username
        .toUpperCase()
        .replace(/^BRCA/, "")
        .trim();

      //console.log("Username nettoyé :", username);

      const foundBrigade = brigade.find(b => {
        const brigadeName = b.name
          .toUpperCase()
          .replace(/^BRCA/, "")
          .trim();
        /* 
                console.log("Brigade testée :", brigadeName);
                console.log("Match ?", username === brigadeName); */

        return username === brigadeName;
      });

      //console.log("Brigade trouvée :", foundBrigade);

      if (foundBrigade) {
        setFormFields(prev => ({
          ...prev,
          brigadeId: foundBrigade.id
        }));
      }
    }
  }, [user, brigade]);

  useEffect(() => {
    if (formFields.brigadeId) {
      axios.get(`/bataillon/${formFields.brigadeId}`).then((res) => {
        const filtered = res.data; // ou filtrer côté frontend si nécessaire
        setBataillon(filtered);
      });
    } else {
      setBataillon([]);
      setFormFields(prev => ({
        ...prev,
        bataillonId: '',
        compagnieId: '',
      }));
    }
  }, [formFields.brigadeId]);

  useEffect(() => {
    if (user?.roles === "USER" && bataillon.length > 0) {
      setFormFields(prev => ({
        ...prev,
        bataillonId: bataillon[0].id
      }));
    }
  }, [bataillon, user]);




  useEffect(() => {
    if (formFields.bataillonId) {
      axios.get(`compagnie/${formFields.bataillonId}`).then((res) => setCompagnie(res.data.compagnie));
    } else {
      setCompagnie([]);
      setFormFields((prevData) => ({ ...prevData, compagnieId: '' }));
    }

    axios.get('/boadss').then((response) => {
      setBoaDss(response.data);
    });
  }, [formFields.bataillonId]);

  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;

    setFormFields((prev) => {
      // 🔁 Cas spécial : Export Excel
      if (name === "exportExcel" && type === "checkbox") {
        return {
          ...prev,
          exportExcel: checked,
          nonVerifier: checked ? false : prev.nonVerifier, // ❌ désactiver l'autre
        };
      }

      // 🔁 Cas spécial : Personnel non vérifié
      if (name === "nonVerifier" && type === "checkbox") {
        return {
          ...prev,
          nonVerifier: checked,
          exportExcel: checked ? false : prev.exportExcel, // ❌ désactiver l'autre
        };
      }

      // 🔁 Cas normal
      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };


  /* const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields({
      ...formFields,
      [name]: value,
    });
  }; */


  const supprimerPDL = async () => {
    if (!formFields.pdl) {
      return toast.error("Veuillez cocher la case PDL !");
    }
    if (!formFields.annee.trim()) {
      return toast.error("Veuillez saisir l'année !");
    }
    if (!formFields.vague.trim()) {
      return toast.error("Veuillez saisir la vague !");
    }

    try {
      const token = localStorage.getItem("accessToken");

      const res = await axios.delete("/personnel/delete-pdl/v/25", {
        headers: { Authorization: `Bearer ${token}` },
        data: {   // DELETE → data obligatoire
          annee: formFields.annee,
          vague: formFields.vague
        }
      });

      toast.success(res.data.message);

    } catch (err) {
      toast.error(err.response?.data?.error || "Erreur lors de la suppression");
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("accessToken");

    try {
      const config = {
        params: formFields,
        headers: { Authorization: `Bearer ${token}` }
      };

      // 👉 Si export Excel activé
      if (formFields.exportExcel) {
        config.responseType = "blob";   // ⬅ obligatoire
      }

      const res = await axios.get("/personnel", config);

      if (formFields.exportExcel) {
        // 👉 On récupère le fichier reçu
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // 👉 On crée un lien de téléchargement
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Liste_Personnels_${Date.now()}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);

        toast.success("Fichier Excel téléchargé !");
        return; // éviter d'exécuter setPersonnels etc.
      }

      // Sinon → Retour normal en JSON
      setPersonnels(res.data.personnels);
      setStats(res.data.stats);

    } catch (err) {
      toast.error(err.response?.data?.error || "Erreur");
    }
  };

  const handleExportExcelChange = (checked) => {
    setFormFields(prev => ({
      ...prev,
      exportExcel: checked,
      // ⛔ si on décoche export → on décoche nonVerifier aussi
      nonVerifier: checked ? prev.nonVerifier : false,
    }));
  };
  const handleNonVerifierChange = (checked) => {
    setFormFields(prev => ({
      ...prev,
      // 🔒 nonVerifier implique exportExcel
      exportExcel: checked ? true : prev.exportExcel,
      nonVerifier: checked,
    }));
  };

  return (
    <div className="container">
      <h1>Recherche</h1>
      <hr />
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <label htmlFor="brigade">Brigade : </label>
            <select
              value={formFields.brigadeId}
              onChange={handleInputChange}
              id="brigadeId"
              name="brigadeId"
              className="form-control"
              disabled={user?.roles === "USER"}   // 🔥 clé ici
            >
              <option value=""></option>

              {brigade.map((b, key) => (
                <option key={key} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
            {/*             <select value={formFields.brigadeId} onChange={handleInputChange} id="brigadeId" name="brigadeId" className="form-control">
              <option value=""></option>
              {brigade.map((brigade, key) => {
                return (
                  <option key={key} value={brigade.id}>
                    {brigade.name}
                  </option>
                );
              })}
            </select> */}
          </div>
          <div className="col">
            <label htmlFor="brigade">Bataillon : </label>
            <select
              value={formFields.bataillonId}
              onChange={handleInputChange}
              id="bataillonId"
              name="bataillonId"
              className="form-control"
            >
              <option value=""></option>
              {bataillon.length > 0 &&
                bataillon.map((b, key) => (
                  <option key={key} value={b.id}>
                    {b.name}
                  </option>
                ))}
            </select>

            {/*  <select value={formFields.bataillonId} onChange={handleInputChange} id="bataillonId" name="bataillonId" className="form-control">
              <option value=""></option>
              {formFields.brigadeId.length > 0
                ? bataillon.map((bataillon, key) => {
                  return (
                    <option key={key} value={bataillon.id}>
                      {bataillon.name}
                    </option>
                  );
                })
                : ''}
            </select> */}
          </div>
          <div className="col">
            <label htmlFor="compagnie">Compagnie : </label>
            <select value={formFields.compagnieId} onChange={handleInputChange} id="compagnieId" name="compagnieId" className="form-control">
              <option value=""></option>
              {formFields.bataillonId.length > 0
                ? compagnie.map((compagnie, key) => {
                  return (
                    <option key={key} value={compagnie.id}>
                      {compagnie.name} - ({compagnie.id})
                    </option>
                  );
                })
                : ''}
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label>Nom et prénoms :</label>
            <input type="text" value={formFields.nomprenom} onChange={handleInputChange} className="form-control" name="nomprenom" />
          </div>
          <div className="col">
            <label>Ets ou Service:</label>
            <select name="etsouserviceId" value={formFields.etsouserviceId} onChange={handleInputChange} className="form-control">
              <option value=""></option>
              {etsouservice.map((service) => (
                <option key={service.id} value={service.id}>
                  {service.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col">
            <label>Grade:</label>
            <select name="gradeId" value={formFields.gradeId} onChange={handleInputChange} className="form-control">
              <option value=""></option>
              {grades.map((grade) => (
                <option key={grade.id} value={grade.id}>
                  {grade.name}- {grade.grademer} - {grade.gradeair}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label>Opérationnels/ Stages/ Détachés:</label>
            <select value={formFields.operation} onChange={handleInputChange} className="form-control" name="operation">
              <option value="">Séléctionné un option</option>
              <option value="MISSION"> MILITAIRE EN OPERATION </option>
              <option value="DETACHE"> MILITAIRE DETACHE </option>
              <option value="STAGEINTERNE"> STAGE INTERNE </option>
              <option value="STAGEEXTERNE"> STAGE EXTERNE </option>
            </select>
          </div>
          <div className="col-md-4">
            <label>Lieu :</label>
            <select value={formFields.boadssId} onChange={handleInputChange} className="form-control" name="boadssId">
              <option value="">Sélectionner BOA OU DSS</option>
              {boaDss.map((boadss) => (
                <option key={boadss.id} value={boadss.id}>
                  {boadss.bataillonoudss}
                </option>
              ))}
            </select>
          </div>

          <div className="col ">
            <label>Fonction :</label>
            <input type="text" value={formFields.fonction} onChange={handleInputChange} className="form-control" name="fonction" />
          </div>

          {/* <div className="col-md-4">
            <label>Options :</label>
            <select value={formFields.fonction} onChange={handleInputChange} className="form-control" name="fonction">
              <option value=""></option>
              <option value="off tres"> OFF TRES </option>
              <option value="s-off tres"> S-OFF TRES </option>
              <option value="off ord"> OFF ORD </option>
              <option value="s-off ord"> S-OFF ORD </option>
            </select>
          </div> */}
        </div>
        <div className='row' >
          <div className='col-md-4' >
            <label htmlFor="diplomeadministratif">Spécialité : </label>
            <select onChange={handleInputChange} id="diplomeadministratif" name="diplomeadministratif" className="form-control">
              <option value=""></option>
              <option value="TRESORIER">TRESORIER</option>
              <option value="INFANTERIE">INFANTERIE</option>
              <option value="CHANCELLERIE">CHANCELLERIE</option>
              <option value="TRANSMISSION">TRANSMISSION</option>
              <option value="INFORMATICIEN">INFORMATICIEN</option>
              <option value="MECANICIEN">MECANICIEN</option>
              <option value="ELECTRICIEN">ELECTRICIEN</option>
              <option value="ADMINISTRATION">ADMINISTRATION</option>
            </select>
          </div>
        </div>


        <div className='row' >
          <div className='col-md-4' >
            <label>Type Pers :</label>
            <select value={formFields.observation} onChange={handleInputChange} className="form-control" name="observation">
              <option value=""></option>
              {/*               <option value="OFF"> OFF </option>
              <option value="S-OFF"> S-OFF </option>
              <option value="ADL"> ADL </option> */}
              <option value="PDL"> PDL </option>
            </select>
          </div>
          <div className='col-md-2' >
            <label>Année :</label>
            <input type="text" value={formFields.annee} onChange={handleInputChange} className="form-control" name="annee" />
          </div>
          <div className='col-md-2' >
            <label>Vague :</label>
            <input type="text" value={formFields.vague} onChange={handleInputChange} className="form-control" name="vague" />
          </div>
        </div>
        <div className="row">
          <div className="col pt-3 ">
            <div className="col pt-3">
              <button className="btn btn-warning" type="submit">
                Recherche...
              </button>
            </div>
          </div>
          <div className="col pt-3 ">
            <div class="form-check">
              <input
                type="checkbox"
                checked={formFields.exportExcel}
                onChange={e => handleExportExcelChange(e.target.checked)}
              />
              <label>Exporter en Excel</label>
              {/* <input
                type="checkbox"
                className="form-check-input"
                id="exportExcel"
                name="exportExcel" // ✅ important
                checked={formFields.exportExcel}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="exportExcel">
                Exporte vers Excel
              </label> */}
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                checked={formFields.nonVerifier}
                disabled={!formFields.exportExcel}
                onChange={e => handleNonVerifierChange(e.target.checked)}
              />
              <label>Personnel non vérifié</label>
              {/* <input
                type="checkbox"
                className="form-check-input"
                id="nonVerifier"
                name="nonVerifier"
                checked={formFields.nonVerifier}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="nonVerifier">
                Personnel non vérifié
              </label> */}
            </div>
          </div>
        </div>


        <div className='row mt-3 bg-success p-3 '>
          <div className="col-md-2">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="pdl"
                name="pdl"
                checked={formFields.pdl}
                onChange={handleInputChange}
              />
              <label className="form-check-label">PDL</label>
            </div>
          </div>

          {/* 🔥 Année */}
          <div className="col-md-2">
            <input
              type="text"
              name="annee"
              value={formFields.annee}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Année"
            />
          </div>

          {/* 🔥 Vague */}
          <div className="col-md-2">
            <input
              type="text"
              name="vague"
              value={formFields.vague}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Vague"
            />
          </div>

          {/* 🔥 Bouton Supprimer */}
          <div className="col-md-3">
            <button
              type="button"
              className="btn btn-danger"
              onClick={supprimerPDL}
            >
              Supprimer
            </button>
          </div>
        </div>

      </form>
    </div>
  );
};

export default SearchForm;
